import React from "react";
import BottomBarNavigationItem from "./BottomBarNavigationItem.js";
import { FormattedMessage } from "react-intl";
import { LocalizationMessages } from "../../../localization/messages.js";
import PropTypes from "prop-types";

const LinkBottomBarNavigationItem = props => {
  const { href, gaLabel, iconLabel, dataTestId } = props;
  const buttonNameOptions = {
    football: LocalizationMessages.bottomNavigationFootball,
    promotions: LocalizationMessages.promotions
  };
  const translatedIconLabel = buttonNameOptions[iconLabel] ?? {
    defaultMessage: ""
  };

  return (
    <BottomBarNavigationItem
      iconColor={"white"}
      iconLabel={iconLabel}
      dataTestId={dataTestId}
      googleAnalyticsLabel={gaLabel}
      itemType={"link"}
      href={href}
    >
      <FormattedMessage {...translatedIconLabel} />
    </BottomBarNavigationItem>
  );
};

LinkBottomBarNavigationItem.propTypes = {
  href: PropTypes.string,
  gaLabel: PropTypes.string,
  iconLabel: PropTypes.string,
  dataTestId: PropTypes.string
};

export default React.memo(LinkBottomBarNavigationItem);
